import type { GetListsParams } from '@vlabs/api/artemy/model';
import { createGenericFiltersContext } from '@vlabs/monokit/shared/lib';

const [
  useListListPageFilters,
  ListListPageFiltersProvider,
] = createGenericFiltersContext<GetListsParams>({
  displayName: 'ListListPageFilters',
});

export {
  useListListPageFilters,
  ListListPageFiltersProvider,
};
